// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { type FC } from 'react';
import { ResponsivePie } from '@nivo/pie';
import { BasicTooltip } from '@nivo/tooltip';
import { SERIES_COLORS } from '@shared/ui-kit/utils/series-colors';

interface DonutChartProps {
  data: {
    id: string;
    label: string;
    value: number;
  }[];
}

export const DonutChart: FC<DonutChartProps> = ({ data }) => {
  return (
    <ResponsivePie
      data={data}
      margin={{ top: 12, right: 12, bottom: 12, left: 12 }}
      sortByValue={true}
      innerRadius={0.75}
      cornerRadius={1}
      valueFormat=" >-.2p"
      activeOuterRadiusOffset={3}
      borderWidth={1}
      borderColor={{
        from: 'color',
        modifiers: [['darker', 0.2]],
      }}
      colors={SERIES_COLORS}
      enableArcLinkLabels={false}
      arcLinkLabelsSkipAngle={10}
      arcLinkLabelsTextColor="#333333"
      arcLinkLabelsThickness={2}
      arcLinkLabelsColor={{ from: 'color' }}
      enableArcLabels={false}
      arcLabelsSkipAngle={10}
      arcLabelsTextColor={{
        from: 'color',
        modifiers: [['darker', 2]],
      }}
      tooltip={({ datum: { color, label, formattedValue } }) => (
        <BasicTooltip id={label} enableChip color={color} value={formattedValue} />
      )}
      animate={false}
    />
  );
};
